import React, { useEffect, useContext, useState } from "react";
import { Form, Input, Button, Checkbox, Cascader, Select } from "antd";
import { UserContext } from "../../../context/UserContext";
import { DROPDOWNS } from "../../../consts";
import { getAllowedRoles } from "../../../utils/api";

const { Option } = Select;

const EditModalContent = ({ data, setOpen, updateCallback, siteData }) => {
  const { userData } = useContext(UserContext);
  const [form] = Form.useForm();
  const [allowedRoles, setAllowedRoles] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);

  const fetchAllowedRoles = async () => {
    if (siteData && siteData.length > 0) {
      const allowedRolesRes = await getAllowedRoles(
        siteData[0].organization_id,
      );
      const visibleRoles = (allowedRolesRes.data.data || []).filter(
        (role) => role.is_visible_for_assignment,
      );
      setAllowedRoles(visibleRoles);
    }
  };

  useEffect(() => {
    fetchAllowedRoles();
  }, [siteData]);

  useEffect(() => {
    if (data?.roles && data.roles.length > 0) {
      const currentRoleIds = data.roles.map((r) => r.id);
      setSelectedRoles(currentRoleIds);
    }
  }, [data, allowedRoles]);

  const onFinish = (values) => {
    values.site_admin_ids = values.site_admin_ids
      ? values.site_admin_ids.map((site) => site[1])
      : [];
    values.site_ids = values.site_ids
      ? values.site_ids.map((site) => site[1])
      : [];

    // Add the selected roles to the submitted values
    values.roles = selectedRoles;

    console.log("Success:", values);
    updateCallback(data.id, values);
    setOpen(false);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleRoleChange = (roleIds) => {
    setSelectedRoles(roleIds);
  };

  return (
    <div className="flex justify-center ">
      <Form
        id="editUserForm"
        form={form}
        className="max-w-[80%]"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <div className="flex items-center justify-around">
          <Form.Item
            className="mr-2"
            name="first_name"
            label="First Name"
            initialValue={data?.first_name}
            rules={[{ required: true, message: "Required" }]}
          >
            <Input placeholder="First Name" />
          </Form.Item>
          <Form.Item
            name="last_name"
            label="Last Name"
            initialValue={data?.last_name}
            rules={[{ required: true, message: "Required" }]}
          >
            <Input placeholder="Last Name" />
          </Form.Item>
        </div>
        <Form.Item
          name="email"
          label="Email"
          initialValue={data?.email}
          rules={[{ required: true, message: "Required" }]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        <div className="flex items-center justify-between">
          <Form.Item
            name="site_ids"
            label="Sites"
            initialValue={data?.sites?.map((site) => [
              site.growing_environment,
              site.id,
            ])}
          >
            <Cascader
              multiple
              className="min-w-[100px]"
              maxTagCount="responsive"
              options={DROPDOWNS.GROWING_ENVIRONMENTS.map((env) => ({
                label: env.label,
                value: env.value,
                disableCheckbox: true,
                children: siteData
                  .filter((site) => site?.growing_environment === env.value)
                  .map((filteredSite) => ({
                    label: filteredSite.name,
                    value: filteredSite.id,
                  })),
              }))}
            />
          </Form.Item>
          <Form.Item
            name="site_admin_ids"
            label="Site Admin"
            initialValue={data?.site_admins?.map((site) => [
              site.growing_environment,
              site.id,
            ])}
          >
            <Cascader
              multiple
              className="min-w-[100px]"
              maxTagCount="responsive"
              options={DROPDOWNS.GROWING_ENVIRONMENTS.map((env) => ({
                label: env.label,
                value: env.value,
                disableCheckbox: true,
                children: siteData
                  .filter((site) => site?.growing_environment === env.value)
                  .map((filteredSite) => ({
                    label: filteredSite.name,
                    value: filteredSite.id,
                  })),
              }))}
            />
          </Form.Item>
        </div>

        {/* Roles selection */}
        <Form.Item label="Roles">
          <Select
            mode="multiple"
            placeholder="Select roles"
            value={selectedRoles}
            onChange={handleRoleChange}
          >
            {allowedRoles.map((role) => (
              <Option key={role.id} value={role.id}>
                {role.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <div className="flex items-center justify-between">
          {userData?.is_superuser && (
            <Form.Item
              name="is_superuser"
              valuePropName="checked"
              label="Superuser"
              initialValue={data?.is_superuser}
            >
              <Checkbox />
            </Form.Item>
          )}
          {(userData?.is_superuser || userData?.is_admin) && (
            <Form.Item
              name="is_admin"
              valuePropName="checked"
              label="Admin"
              initialValue={data?.is_admin}
            >
              <Checkbox />
            </Form.Item>
          )}
          <Form.Item
            name="is_active"
            valuePropName="checked"
            label="Active"
            initialValue={data?.is_active}
          >
            <Checkbox />
          </Form.Item>
        </div>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default EditModalContent;
